import ProfileImage from "common/components/ui/ProfileImage";
import Skeleton from "common/components/ui/Skeleton";

import type { LinkedInPost } from "../../../../types";

interface PostPreviewProps {
  post: LinkedInPost;
  isLoading: boolean;
}

export default function PostPreview({ post, isLoading }: PostPreviewProps) {
  return (
    <article className="flex-1 overflow-hidden rounded-3xl border border-black-200">
      {/* Post Author */}
      <div className="flex items-center gap-3.5 border-b border-b-black-200 p-3">
        {isLoading ? (
          <Skeleton className="size-12 shrink-0 rounded-full" />
        ) : (
          <ProfileImage size="lg" src={post.author.image.url} />
        )}
        <div className="flex w-full flex-col gap-1">
          {isLoading ? (
            <>
              <Skeleton className="h-7 w-3/6" />
              <Skeleton className="h-5 w-4/6" />
            </>
          ) : (
            <>
              <h5 className="text-lg-bold">{post.author.name}</h5>
              <span className="line-clamp-1 text-black-500">
                {post.author.subtitle}
              </span>
            </>
          )}
        </div>
      </div>

      {/* Post Details Preview */}
      {isLoading ? (
        <>
          <Skeleton className="h-96 w-full rounded-none" />
          <div className="flex flex-col gap-1.5 p-4">
            <Skeleton className="h-5 w-full" />
            <Skeleton className="h-5 w-full" />
            <Skeleton className="h-5 w-8/12" />
          </div>
        </>
      ) : (
        <>
          {post.images && (
            <img src={post.images[0][0].url} alt="LinkedIn Post" />
          )}
          {post.text && (
            <div className="p-3">
              <p className="line-clamp-6 text-black-700">{post.text}</p>
            </div>
          )}
        </>
      )}
    </article>
  );
}
